import { z } from "zod";
import { declareNotification, declareRequest } from "@gitlab-org/rpc";
//#region src/worker_rpc.ts
const WorkerContextSchema = z.object({
	workspaceFolderPath: z.string(),
	workspaceFolderUri: z.string().optional(),
	workflowId: z.string(),
	gitlabBaseUrl: z.string(),
	gitlabToken: z.string()
});
const PlainTextResponseSchema = z.object({
	response: z.string(),
	error: z.string()
});
const HttpResponseSchema = z.object({
	headers: z.record(z.string(), z.string()),
	statusCode: z.number(),
	body: z.string(),
	error: z.string()
});
const ScheduleNotificationResponseSchema = z.object({
	accepted: z.boolean(),
	reason: z.string(),
	fires_at: z.string()
});
const WorkerActionResponseSchema = z.union([
	PlainTextResponseSchema,
	HttpResponseSchema,
	ScheduleNotificationResponseSchema
]);
const WorkerActionRequestSchema = z.object({
	action: z.record(z.string(), z.unknown()),
	context: WorkerContextSchema
});
const ExecuteActionRequest = declareRequest("$/worker/executeAction").withParams(WorkerActionRequestSchema).withResponse(WorkerActionResponseSchema).build();
const WorkerReadyNotification = declareNotification("$/worker/ready").build();
const WorkerShutdownNotification = declareNotification("$/worker/shutdown").build();
const CancelActionNotification = declareNotification("$/worker/cancelAction").withParams(z.object({ requestID: z.string() })).build();
//#endregion
export { WorkerActionRequestSchema as a, WorkerReadyNotification as c, PlainTextResponseSchema as i, WorkerShutdownNotification as l, ExecuteActionRequest as n, WorkerActionResponseSchema as o, HttpResponseSchema as r, WorkerContextSchema as s, CancelActionNotification as t };

//# sourceMappingURL=worker_rpc-Di8KN-kG.mjs.map